import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactModal from "react-modal";
import { ModalContents, modalStyle, ModalTitle } from "./Modal.styled";
import Button from "../Button/Button";
import CloseXIcon from "../../assets/closeIcon";
var Modal = function (_a) {
    var isOpen = _a.isOpen, title = _a.title, closeButton = _a.closeButton, contents = _a.contents, onClose = _a.onClose;
    return (_jsxs(ReactModal, { isOpen: isOpen, onRequestClose: onClose, contentLabel: title, style: modalStyle, ariaHideApp: false, children: [_jsxs(ModalTitle, { children: [title, closeButton ? (_jsx(Button, { variant: "inputButton", onClick: onClose, children: _jsx(CloseXIcon, {}) })) : null] }), _jsx(ModalContents, { children: contents })] }));
};
export default Modal;
//# sourceMappingURL=Modal.js.map